// Auto-generated file

import * as React from "react";
import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "email-identifier-challenge": lazy(() => import("@/screens/email-identifier-challenge")),
  "login": lazy(() => import("@/screens/login")),
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "login-passwordless-email-code": lazy(() => import("@/screens/login-passwordless-email-code")),
  "login-passwordless-sms-otp": lazy(() => import("@/screens/login-passwordless-sms-otp")),
  "mfa-begin-enroll-options": lazy(() => import("@/screens/mfa-begin-enroll-options")),
  "mfa-country-codes": lazy(() => import("@/screens/mfa-country-codes")),
  "mfa-email-challenge": lazy(() => import("@/screens/mfa-email-challenge")),
  "mfa-email-list": lazy(() => import("@/screens/mfa-email-list")),
  "mfa-enroll-result": lazy(() => import("@/screens/mfa-enroll-result")),
  "mfa-login-options": lazy(() => import("@/screens/mfa-login-options")),
  "mfa-push-challenge-push": lazy(() => import("@/screens/mfa-push-challenge-push")),
  "mfa-push-enrollment-qr": lazy(() => import("@/screens/mfa-push-enrollment-qr")),
  "mfa-push-list": lazy(() => import("@/screens/mfa-push-list")),
  "mfa-push-welcome": lazy(() => import("@/screens/mfa-push-welcome")),
  "mfa-sms-challenge": lazy(() => import("@/screens/mfa-sms-challenge")),
  "mfa-sms-enrollment": lazy(() => import("@/screens/mfa-sms-enrollment")),
  "mfa-sms-list": lazy(() => import("@/screens/mfa-sms-list")),
  "passkey-enrollment": lazy(() => import("@/screens/passkey-enrollment")),
  "passkey-enrollment-local": lazy(() => import("@/screens/passkey-enrollment-local")),
  "phone-identifier-challenge": lazy(() => import("@/screens/phone-identifier-challenge")),
  "phone-identifier-enrollment": lazy(() => import("@/screens/phone-identifier-enrollment")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-email": lazy(() => import("@/screens/reset-password-email")),
  "reset-password-error": lazy(() => import("@/screens/reset-password-error")),
  "reset-password-request": lazy(() => import("@/screens/reset-password-request")),
  "reset-password-success": lazy(() => import("@/screens/reset-password-success")),
  "signup": lazy(() => import("@/screens/signup")),
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "signup-password": lazy(() => import("@/screens/signup-password"))
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
